import styled from 'styled-components';

import { TextBodyNormal } from '@/core/components/Typography/Typography.styles';

export const Title = styled(TextBodyNormal)`
  margin-block: 24px 8px;
  color: ${({ theme }) => theme.colors.secondaryText};
`;
